export const server =
  "https://equipment-validate-backend-production.up.railway.app/v1/api";
// export const server = "http://localhost:8000/v1/api";
